import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import { usePaymentFormContext } from '../../context/PaymentFormContext';
import AcknowledgementCheckbox from './AcknowledgementCheckbox';
import { useMerchantPolicySettings } from '../../hooks/useMerchantPolicySettings';
import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ZeroCheckoutTermsOfService from './ZeroCheckoutTermsOfService';
import { ExternalLinkIcon } from 'foundations-assets';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const getMessage = ({
  translationMessageKey,
  termsOfServiceUrl,
  companyName,
  isZeroCheckout
}) => {
  if (isZeroCheckout) {
    return /*#__PURE__*/_jsx(ZeroCheckoutTermsOfService, {});
  } else if (!translationMessageKey) {
    return null;
  } else if (termsOfServiceUrl) {
    if (companyName) {
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: translationMessageKey,
        options: {
          href: termsOfServiceUrl,
          iconColor: 'icon-core-subtle',
          companyName
        },
        elements: {
          Link: UILink,
          Icon: ExternalLinkIcon
        }
      });
    } else {
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: translationMessageKey,
        options: {
          href: termsOfServiceUrl,
          iconColor: 'icon-core-subtle'
        },
        elements: {
          Link: UILink,
          Icon: ExternalLinkIcon
        }
      });
    }
  } else if (companyName) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: translationMessageKey,
      options: {
        companyName
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: translationMessageKey
  });
};
const TermsOfService = ({
  translationMessageKey,
  isZeroCheckout
}) => {
  var _checkoutSession$poli;
  const {
    checkoutSession: checkoutSessionMap
  } = usePaymentFormContext();
  const checkoutSession = checkoutSessionMap.toJS();
  const companyName = checkoutSession.branding && checkoutSession.branding.companyName;
  const termsOfServiceUrl = ((_checkoutSession$poli = checkoutSession.policySettingsData) === null || _checkoutSession$poli === void 0 ? void 0 : _checkoutSession$poli.termsOfServiceUrl) || '';
  const {
    displayAcknowledgementCheckbox
  } = useMerchantPolicySettings(checkoutSession);
  const message = useMemo(() => getMessage({
    translationMessageKey,
    termsOfServiceUrl,
    companyName,
    isZeroCheckout
  }), [translationMessageKey, termsOfServiceUrl, companyName, isZeroCheckout]);
  if (!message) {
    return null;
  }
  return /*#__PURE__*/_jsx(View, {
    paddingBlockStart: "300",
    children: displayAcknowledgementCheckbox ? /*#__PURE__*/_jsx(AcknowledgementCheckbox, {
      children: message
    }) : message
  });
};
export default TermsOfService;